import { useSelector } from "react-redux";
import classes from './TrainingRoom.module.css'
import BackArrowTitle from "../../UI/BackArrowTitle";
import { useNavigate } from "react-router-dom"
import TrainingsPage from "../Admin/Trainings/TrainingsPage";

const TrainingRoom = () => {
    const navigate = useNavigate();
    const { texts } = useSelector(state => state.translate);
    const homeUrl = useSelector((state) => state.application.homeUrl);


    return (
        <div className={classes.TrainingRoom}>
            <BackArrowTitle text={texts.trainingRoom} onClick={() => { navigate(`${homeUrl}`) }} />
            <TrainingsPage view={true}></TrainingsPage>
        </div>
    )
}
export default TrainingRoom